<script setup lang="ts">
import { Content } from '~/components/ui/content'
</script>
<template>
  <Content>
    <h2>{{ $t('widget.about_page.comments_suggestions.title') }}</h2>
    <p>
      <i18n-t keypath="widget.about_page.comments_suggestions.paragraph_1" scope="global">
        <template #press_email>
          <a
            href="mailto:press@banks.kg"
            :aria-label="
              $t('widget.about_page.comments_suggestions.aria_label_email', {
                email: 'press@banks.kg'
              })
            "
            >press@banks.kg</a
          >
        </template>
        <template #info_email>
          <a
            href="mailto:info@banks.kg"
            :aria-label="
              $t('widget.about_page.comments_suggestions.aria_label_email', {
                email: 'info@banks.kg'
              })
            "
            >info@banks.kg</a
          >
        </template>
        <template #phone>
          <a
            href="tel:+996555204444"
            :aria-label="
              $t('widget.about_page.comments_suggestions.aria_label_phone', {
                phone: '+996 (555) 20 44 44'
              })
            "
            >+996 (555) 20 44 44</a
          >
        </template>
      </i18n-t>
    </p>
    <p>{{ $t('widget.about_page.comments_suggestions.paragraph_2') }}</p>
  </Content>
</template>
